import { computed, inject, type ComputedRef } from 'vue'
import type { DataTableContext } from './types'

export const useDataTable = (): {
  context: ComputedRef<ReturnType<DataTableContext>>
} => {
  const dataTableContext = inject<DataTableContext>('dataTableContext', () => {
    return {
      rowFieldIdentifier: 'name',
      resetTableOrder: (): void => {},
      selectRow: (): void => {},
      deselectRow: (): void => {},
      selectAll: (): void => {},
      deselectAll: (): void => {},
      toggleTableOrder: (): void => {},
    }
  })

  return {
    context: computed(() => dataTableContext()),
  }
}
